@if (onlineBooking()) {
  <div [formGroup]="form" class="modal">
    <div nz-row class="user-item">
      <div nz-col nzFlex="1">
        <div>
          {{ onlineBooking().user.fullName }}
        </div>
        <div>
          {{ onlineBooking().user.mobilePhone }}
        </div>
      </div>
      <div nz-col nzFlex="1">
        კომენტარი:
        <div [innerText]="onlineBooking().description">
        </div>
      </div>
    </div>

    @if (!hasPerServiceScheduling()) {
      <div nz-row [nzGutter]="20">
        <div nz-col [nzSpan]="8">
          <ng-container *ngxPermissionsExcept="['Employee']">
            <beautyapp-select
              formControlName="employeeId"
              [data]="employee$ | async"
              label="{{ 'calendar.form.employee' | translate }}"
              placeholder="{{ 'calendar.form.employee' | translate }}"
              valueMember="id"
              displayMember="fullName"
              required
            ></beautyapp-select>
          </ng-container>
        </div>
        <div nz-col [nzSpan]="6">
          <beautyapp-datepicker
            label="{{ 'calendar.form.date' | translate }}"
            placeholder="{{ 'calendar.form.date' | translate }}"
            formControlName="bookingDate"
            required
          ></beautyapp-datepicker>
        </div>
        <div nz-col [nzSpan]="3">
          <beautyapp-time-picker
            label="{{ 'calendar.form.startingTime' | translate }}"
            placeholder="{{ 'calendar.form.startingTime' | translate }}"
            formControlName="startTime"
            required
          ></beautyapp-time-picker>
        </div>
        <div nz-col [nzSpan]="3">
          <beautyapp-time-picker
            label="{{ 'calendar.form.finishingTime' | translate }}"
            placeholder="{{ 'calendar.form.finishingTime' | translate }}"
            formControlName="endTime"
            required
          ></beautyapp-time-picker>
        </div>
        @if (form.getError('dateRange')) {
          <div nz-col [nzSpan]="24" nz-typography nzType="danger">
            {{ 'calendar.form.errors.dateRangeError' | translate }}
          </div>
        }
      </div>
    }
    <nz-divider nzText="პროცედურები"/>
    @if (onlineBooking().services && onlineBooking().services.length) {
      @for (service of onlineBooking().services; track service; let i = $index) {
        <nz-card class="service-card" [nzBordered]="true">
          <div nz-row nzJustify="space-between" nzAlign="top">
            <!-- Service Info -->
            <div nz-col nzFlex="1">
              <div class="service-header" [style.border-left-color]="service?.serviceCategory?.color || '#1890ff'">
                <div class="service-name">{{ service?.name || 'სერვისი' }}</div>
                <div class="service-price">{{ service?.price }} ₾</div>
              </div>
              <div class="service-meta">
                <nz-tag nzColor="blue">
                  <span nz-icon nzType="clock-circle"></span>
                  {{ service?.duration || service?.time }} წთ
                </nz-tag>
                @if (service?.employeeName) {
                  <nz-tag nzColor="purple">
                    <span nz-icon nzType="user"></span>
                    {{ service.employeeName }}
                  </nz-tag>
                }
                @if (service?.bookingDate) {
                  <nz-tag nzColor="green">
                    <span nz-icon nzType="calendar"></span>
                    {{ formatServiceDate(service.bookingDate) }}
                  </nz-tag>
                }
                @if (service?.startTime) {
                  <nz-tag nzColor="orange">
                    <span nz-icon nzType="field-time"></span>
                    {{ formatServiceTime(service.startTime) }}
                    @if (service?.endTime) {
                      - {{ formatServiceTime(service.endTime) }}
                    }
                  </nz-tag>
                }
              </div>
            </div>
            <!-- Actions -->
            <div nz-col nzFlex="initial" class="service-actions">
              <button nz-button nzType="default" nzShape="circle"
                nz-tooltip nzTooltipTitle="გადანიშვნა"
                (click)="openRescheduleDrawer(service, i)">
                <span nz-icon nzType="calendar" nzTheme="outline"></span>
              </button>
            </div>
          </div>
        </nz-card>
      }
    }
    <nz-divider/>
    <div class="price-summary">
      <div nz-row nzJustify="space-between" class="price-row">
        <span>ფასი ჯამში:</span>
        <span class="price-value">{{ onlineBooking()?.totalPrice | number:'1.2-2' }} ₾</span>
      </div>
      @if (onlineBooking()?.paidAmount > 0) {
        <div nz-row nzJustify="space-between" class="price-row paid">
          <span>გადახდილი (ავანსი):</span>
          <span class="price-value paid-amount">{{ onlineBooking()?.paidAmount | number:'1.2-2' }} ₾</span>
        </div>
        <div nz-row nzJustify="space-between" class="price-row remaining">
          <span>დარჩენილი თანხა:</span>
          <span class="price-value remaining-amount">{{ (onlineBooking()?.totalPrice - onlineBooking()?.paidAmount) | number:'1.2-2' }} ₾</span>
        </div>
      }
    </div>

    <!-- Reject Form -->
    @if (showRejectForm()) {
      <nz-divider nzText="უარყოფის მიზეზი"/>
      <div class="reject-form">
        <nz-radio-group
          [ngModel]="selectedReason()"
          (ngModelChange)="selectedReason.set($event)"
          [ngModelOptions]="{standalone: true}">
          @for (reason of rejectionReasons; track reason.value) {
            <label nz-radio [nzValue]="reason.value">{{ reason.label }}</label>
          }
        </nz-radio-group>
        @if (selectedReason() === 'სხვა') {
          <textarea
            nz-input
            [rows]="3"
            placeholder="მიუთითეთ მიზეზი..."
            [ngModel]="customMessage()"
            (ngModelChange)="customMessage.set($event)"
            [ngModelOptions]="{standalone: true}"
            style="margin-top: 12px;">
          </textarea>
        }
        <div nz-row nzJustify="end" style="margin-top: 12px; gap: 8px;">
          <button nz-button nzType="default" (click)="cancelReject()">გაუქმება</button>
          <button nz-button nzType="primary" nzDanger [nzLoading]="loading()" (click)="confirmReject()">
            უარყოფა
          </button>
        </div>
      </div>
    }
  </div>
  @if (!hasPerServiceScheduling() && employeeBusyTimes().length) {
    <div class="chips">
      <nz-divider nzText="თანამშრომლის არსებული ჯავშნები"/>
      @for (time of employeeBusyTimes(); track time) {
        <div class="chip"
          [ngClass]="{'busy': time.isBusy}"
          >
          {{ time.startTime }} - {{ time.endTime }}
        </div>
      }
    </div>
  }
} @else {
  <div class="loading">
    <nz-spin nzSimple></nz-spin>
  </div>
}



<div *nzModalFooter nz-row nzJustify="space-between">
  <button
    nz-button
    nzType="default"
    [nzLoading]="loading()"
    (click)="modalRef.triggerCancel()"
    >
    {{ 'buttons.close' | translate }}
  </button>
  @if (!showRejectForm()) {
    <div>
      <button
        nz-button
        nzType="primary"
        nzDanger
        [nzLoading]="loading()"
        (click)="showRejectDialog()"
        >
        {{ 'buttons.decline' | translate }}
      </button>
      <button
        nz-button
        nzType="primary"
        [nzLoading]="loading()"
        nz-popconfirm
        nzPopconfirmTitle="{{ 'buttons.accept' | translate }}"
        nzPopconfirmPlacement="top"
        (nzOnConfirm)="accept()"
        >
        {{ 'buttons.accept' | translate }}
      </button>
    </div>
  }
</div>
